import Router from "./components/Router";
const rootPath = "/";
const parentPath = "";

export default {
    rootPath,
    parentPath,
    RootComponent: Router
};
